var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.75 7.063c0-.619.506-1.125 1.125-1.125S38 6.444 38 7.063v12.376a5.624 5.624 0 01-5.626 5.626H5.836l7.081 7.08a1.129 1.129 0 010 1.59 1.129 1.129 0 01-1.59 0l-9-9a1.129 1.129 0 010-1.59l9-9a1.13 1.13 0 011.59 0 1.129 1.129 0 010 1.588l-7.081 7.081h26.538a3.376 3.376 0 003.376-3.375V7.063z"
  })));
}
export default SvgArrowDownLeft;